module.exports = __webpack_public_path__ + "img/Cumulative-Impacts to VECs.aee16de5.svg";